import type { FC } from 'react';

import { PAGE_CONTENT_ID } from '../../constants';

import styles from './ContentContainer.module.scss';

const ContentContainer: FC<IWithReactChildren> = ({ children }) => (
  <div className={styles.contentContainer} id={PAGE_CONTENT_ID}>
    {children}
  </div>
);

export default ContentContainer;
